"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MortgageLegalInfo = require("./MortgageLegalInfo");
Object.keys(_MortgageLegalInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MortgageLegalInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MortgageLegalInfo[key];
    }
  });
});